import React, { Component } from 'react';
import * as aws4 from 'ngx-aws4';

const hasAWS4Signature = WrapperComponent => class extends Component {
    signAWS4Request = ({
      instagramId,
    }) => {
      //
      if (!instagramId) {
        return null;
      }

      const requestOptions = {
        hostname: process.env.REACT_APP_BRANDS_DATA_URL,
        path: `production/influencer/instagram/brands/reports/${instagramId}`,
        region: 'eu-west-1',
        service: 'execute-api',
      };

      const credentials = {
        accessKeyId: process.env.REACT_APP_AWS_KEY_ID,
        secretAccessKey: process.env.REACT_APP_AWS_KEY_SECRET,
      };

      aws4.sign(requestOptions, credentials);

      return requestOptions;
    }
    render() {
      return (<WrapperComponent
        {...this.props}
        signAWS4Request={this.signAWS4Request}
      />);
    }
};

export default hasAWS4Signature;



/** WEBPACK FOOTER **
 ** ./src/hocs/has-aws4-signature/index.js
 **/